import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Row from './Row'
import SegmentFooter from './SegmentFooter'
import Adjustment from './Adjustment'
import DebtAdjustment from './DebtAdjustment'
import { footers } from './helpers/footers'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 7fr;
  grid-column-gap: 0px;
  border-top: 9px solid #f8f8f8;
  border-bottom: 2px solid #dddddd;
  background: #EEEEEE;
`
const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #dfdfdf;
  padding: 40px 0px;
  text-align: center;
  grid-column-start: 1;
  font-weight: bold;
`
const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #EEEEEE;
  grid-column-start: 2;
  grid-column-end: 6;
  justify-content: center;
`
class Segment extends React.Component {
  renderRows = () => {
    const {
      isEditable,
      entityId,
      entityName,
      cellRef,
      moveFns,
      changeCell,
      tabIndices,
      loanId,
      resourceType,
      data,
      fiscalYears,
      years,
      refetch,
      entity,
      interimYears,
      isEditAllowed,
      segmentKey,
      selectedYear,
      selectedCategory,
      yearSources,
      markForDelete,
      saveFromDelete,
      interimPeriods,
      cashflowOptions,
      loan,
      queriedYears,
      markForSave,
      dontSave,
      resetYearSources,
      categories
    } = this.props
    return categories.map(category => {
      const categoryData = data.filter(datum => datum.category === category.key && years.has(datum.year))
      // We exclude the officer_comp row if the product does not use officerCompAddback
      if (!loan.product.officerCompAddback && category.key === 'officer_comp') {
        return
      }
      if (!footers.includes(category.key) && (category.required || categoryData.length > 0) && !category.key.includes('stressed')) {
        return (
          <Row
            key={category.key}
            title={category.title.replace('${Business}', entityName)}
            fiscalYears={fiscalYears}
            years={years}
            data={categoryData}
            isEditable={isEditable}
            category={category}
            entityId={entityId}
            cellRef={cellRef}
            moveFns={moveFns}
            changeCell={changeCell}
            tabIndices={tabIndices}
            loanId={loanId}
            isDerived={category.derived}
            resourceType={resourceType}
            refetch={refetch}
            entity={entity}
            interimYears={interimYears}
            isEditAllowed={isEditAllowed}
            segmentKey={segmentKey}
            selectedCategory={selectedCategory}
            selectedYear={selectedYear}
            yearSources={yearSources}
            markForDelete={markForDelete}
            saveFromDelete={saveFromDelete}
            interimPeriods={interimPeriods}
            cashflowOptions={cashflowOptions}
            queriedYears={queriedYears}
            loan={loan}
            markForSave={markForSave}
            dontSave={dontSave}
            resetYearSources={resetYearSources}
          />
        )
      }
    })
  }
  renderAdjustment = () => {
    const { years, loanId, refetch, resourceType, categories, data, entityId, segmentKey, isEditable, category } = this.props
    const availableCategories = categories.filter(category => {
      return category.key !== 'onetime_expense' && category.key !== 'onetime_reduction' &&
             (data.filter(datum => datum.category === category.key && years.has(datum.year)).length === 0 && !category.required && !category.derived || // see if there is any data for the category
             data.filter(datum => datum.category === category.key && datum.source === 'keyed').every(datum => datum.data === 0) && !category.required && !category.derived) // see if category has been zeroed out
    }).filter(category => category.key !== 'other_personal_income') // other_personal_income is a one-off migration category and should not be selectable
    if (availableCategories.length > 0 && segmentKey !== 'personal_debt' && !isEditable) {
      return (
        <Adjustment
          availableCategories={availableCategories}
          addCategory={this.addCategory}
          years={years}
          loanId={loanId}
          refetch={refetch}
          resourceType={resourceType}
          entityId={entityId}
          segmentKey={segmentKey}
        />
      )
    } else if (availableCategories.length > 0 && segmentKey === 'personal_debt') {
      return (
        <DebtAdjustment
          refetch={refetch}
          entityId={entityId}
          years={years}
          availableCategories={availableCategories}
          loanId={loanId}
          segmentKey={segmentKey}
        />
      )
    }
  }
  renderFooter = () => {
    const { entityName, isEditable, resourceType, entity, fiscalYears, data, years, categories } = this.props
    for (const category of categories) {
      if (footers.includes(category.key)) {
        const d = data.filter(datum => datum.category === category.key && years.has(datum.year))
        return (
          <SegmentFooter
            key={category}
            title={category.title.replace('${Business}', entityName)}
            years={years}
            data={d}
            entityName={entityName}
            isEditable={isEditable}
            resourceType={resourceType}
            entity={entity}
            fiscalYears={fiscalYears}
          />
        )
      }
    }
  }
  render() {
    const { title, segmentKey } = this.props
    return (
      <Container className={segmentKey}>
        <Title>
          {title}
        </Title>
        <RowContainer>
          {this.renderRows()}
          {this.renderAdjustment()}
          {this.renderFooter()}
        </RowContainer>
      </Container>
    )
  }
}

Segment.propTypes = {
  title: PropTypes.string,
  isEditable: PropTypes.bool,
  fiscalYears: PropTypes.array,
  entityId: PropTypes.number,
  cellRef: PropTypes.func
}

export default Segment
